export default function App() {
  return (
    <main>
      <h1>LINE Mini App</h1>
      <p>Hosted on AWS (S3 + CloudFront).</p>
    </main>
  );
}
